import {useAuth} from '../modules/auth'
import {PermissionLevel} from '../modules/auth/core/_models'

interface UsePermissionResult {
  hasAccess: boolean
  canView: boolean
  canEdit: boolean
  userRole: 'admin' | 'user' | undefined
  userPermissions: Record<string, PermissionLevel> | undefined
}

export const usePermission = (
  module: string, 
  requiredLevel?: 'EDIT'
): UsePermissionResult => {
  const {currentUser} = useAuth()
  
  const userRole = currentUser?.role
  const userPermissions = currentUser?.permissions
  
  // Admin users have full access to everything
  const isAdmin = userRole === 'admin'
  
  // Get user's permission level for the module
  const userPermission = userPermissions?.[module] || 'NONE'
  
  // Check if user has the required permission level
  const hasRequiredLevel = (userLevel: PermissionLevel, required: 'EDIT'): boolean => {
    const levels: Record<string, number> = {NONE: 0, EDIT: 1}
    return levels[userLevel] >= levels[required]
  }
  
  const canView = isAdmin || userPermission === 'EDIT'
  const canEdit = isAdmin || userPermission === 'EDIT'
  
  const hasAccess = requiredLevel 
    ? isAdmin || hasRequiredLevel(userPermission, requiredLevel)
    : canView

  return {
    hasAccess,
    canView,
    canEdit,
    userRole,
    userPermissions,
  }
}

export default usePermission
